import Vue from 'vue'
import VeeValidate from 'vee-validate'
import UIkit from 'uikit';
import 'uikit/dist/css/uikit.min.css'
import Icons from 'uikit/dist/js/uikit-icons';
Vue.use(VeeValidate);
// loads the Icon plugin
UIkit.use(Icons);
import Router from 'vue-router'
import Home from './views/Home.vue'
import About from './views/Home.vue'
import ContactUs from "./views/contactUs";
import advisory from "./views/advisory";
import auditAndAssurance from "./views/auditAndAssurance";
import charitiesAndNonProfits from "./views/charitiesAndNonProfits";
import clientList from "./views/clientList";
import financialManagement from "./views/financialManagement";
import financialReporting from "./views/financialReporting";
import pbi from "./views/pbi";
import publicSector from "./views/publicSector";
import vlogs from "./views/vlogs";
import wf from "./views/wf";
import managementTeam from "./views/managementTeam";
import coreValuesMission from "./views/coreValuesMission";
import ComplianceMonitoring from "@/views/ComplianceMonitoring.vue";
import AccountingServices from "@/views/AccountingServices.vue";
import BoardGovernanceAndSupport from "@/views/BoardGovernanceAndSupport.vue";
import Blogs from "@/views/Blogs.vue";
import BoardGovernance from "@/views/BoardGovernance.vue";
import RightVsWrong from "@/views/RightVsWrong.vue";
import Outsourcing from "@/views/Blogs/Outsourcing.vue";

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/', name: 'home', component: Home },
    { path: '/blogs', name: 'Blogs', component: Blogs },
    { path: '/blogs/board-governance', name: 'Blogs - Board Governance', component: BoardGovernance },
    { path: '/blogs/doing-right-things-vs-doing-things-right', name: 'Blogs - Doing right vs doing wrong', component: RightVsWrong },
    { path: '/blogs/focusing-on-what-really-matters-and-saving-money-in-the-process',
      name: 'Blogs - Focusing on what really matters and saving money in the process', component: Outsourcing },
    { path: '/why-choose-fincor-services', name: 'Why Choose Fincor Services', component: wf },
    { path: '/our-management-team', name: 'Management Team', component: managementTeam },
    { path: '/compliance-monitoring-services', name: 'Compliance Monitoring Services', component: ComplianceMonitoring },
    { path: '/accounting-services', name: 'Accounting Services', component: AccountingServices },
    { path: '/board-governance-and-support', name: 'Board Governance & Support', component: BoardGovernanceAndSupport },
    //{ path: '/coreValues', name: 'Core Values, Mission and Vision', component: coreValuesMission },
    { path: '/contact-us', name: 'Contact Us', component: ContactUs },
    { path: '/financial-advisory-services', name: 'Financial Advisory Services', component: advisory },
    { path: '/accountant-reviews-financial-services', name: 'Accountant Reviews Services', component: auditAndAssurance },
    { path: '/charities-and-non-profit-financial-services', name: 'Charities and Non-Profit Services', component: charitiesAndNonProfits },
    { path: '/testimonials', name: 'Testimonials', component: clientList },
    { path: '/financial-management-services', name: 'Financial Management Services', component: financialManagement },
    { path: '/financial-reporting-services', name: 'Financial Reporting Services', component: financialReporting },
    { path: '/private-business-and-individual-financial-services', name: 'Private Business and Individuals', component: pbi },
    { path: '/public-sector-financial-services', name: 'Public Sector Services', component: publicSector },
    { path: '/vlogs', name: 'Vlogs', component: vlogs }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
